class Animation {
  static getcubicBezier = () => {
    return {
      preset01: "0.5, 0.01, 0, 1",
    };
  };
}

export default Animation;
